import { render, staticRenderFns } from "./AdminReportCard.vue?vue&type=template&id=d9f640f4"
import script from "./AdminReportCard.vue?vue&type=script&lang=js"
export * from "./AdminReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports